<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\endCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào biểu tượng [Tiến độ khóa học] ở phần trên màn hình , thì màn hình yêu cầu hoàn thành sẽ được hiển thị.</p>
                    <p>※ Màn hình Yêu cầu hoàn thành sẽ tự động xuất hiện sau khi hoàn thành bài thi cuối kỳ, và Bảng khảo sát (nếu có), Bản cam kết (nếu có)</p>
                </div>
                <div><img src="/static\images\vi\newManual\endCourseManual-2.png" alt="" /></div>
                <div>
                    <p>② Xác nhận tình trạng tiến độ của khóa học.</p>
                    <p>③ Khi hoàn thành xong cả Bảng khảo sát, thì button [Yêu cầu] sẽ trở thành trạng thái được kích hoạt. Khi nhấn nhấn nút [Yêu cầu], thì khóa học đó sẽ kết thúc.</p>
                    <p>※ Sau khi kết thúc khóa học thì bạn không thể quay lại làm Bài thi cuối kỳ được nữa.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                typeLanguage: 3,
            };
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {
            this.typeLanguage = this.$lang();
        },
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/endCourse_manual.vue